import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {DialogTimeComponent} from './dialog-time.component';
import {TimePickerModule} from './time-picker/time-picker.module';

@NgModule({
  declarations: [DialogTimeComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    TimePickerModule
  ],
  exports: [DialogTimeComponent]
})

export class DialogTimeModule {}
